export const initialValuesAssignmentEdit = {
    taskName: "",
    taskDuration: "",
    taskType: "",
    startDate: "",
    startTime: "",
}
